import { Chart } from "primereact/chart";
import { useState, useEffect } from "react";
import RoundedChip from "../roundedChip/RoundedChip";
import { convertToCurrencyFormat } from "../../shared/utility";

export default function LineChart() {
  const [chartData, setChartData] = useState({});
  const [chartOptions, setChartOptions] = useState({});

  useEffect(() => {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue("--text-color");
    const textColorSecondary = documentStyle.getPropertyValue(
      "--text-color-secondary"
    );
    const surfaceBorder = "#E8E8E8";
    const data = {
      labels: ["January", "February", "March", "April", "May", "June", "July"],
      datasets: [
        {
          label: "Sales",
          data: [20, 24, 29, 32, 38, 47, 54],
          fill: false,
          borderColor: "#0caee0",
          tension: 0.4,
        },
      ],
    };
    const options = {
      maintainAspectRatio: false,
      aspectRatio: 1,
      plugins: {
        legend: {
          display: false,
          labels: {
            color: textColor,
          },
        },
      },
      scales: {
        x: {
          ticks: {
            color: textColorSecondary,
          },
          grid: {
            color: surfaceBorder,
          },
        },
        y: {
          ticks: {
            color: textColorSecondary,
          },
          grid: {
            color: surfaceBorder,
          },
        },
      },
    };

    setChartData(data);
    setChartOptions(options);
  }, []);

  return (
    <li className="overflow-hidden h-max rounded-xl border border-gray-200 shadow-md">
      <div className="flex infos-center gap-x-4 border-b border-gray-900/5 bg-gray-50 px-6 py-4">
        <div className="text-xl font-medium leading-6 text-gray-900">
          Sales Summary
        </div>
      </div>

      <div className="bg-white px-6 py-2 grid grid-cols-5 gap-4">
        <Chart
          className="col-span-4"
          type="line"
          data={chartData}
          options={chartOptions}
        />
        <div className="border-l border-gray-200 my-2 p-4 space-y-3">
          <p className="font-bold text-lg">Total Sales</p>

          <div className="chart-explanation p-3">
            <RoundedChip
              title="Sales"
              subtitle={convertToCurrencyFormat(124226)}
              color="bg-chart-blue"
            />
          </div>
        </div>
      </div>
    </li>
  );
}
